import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import Home from '../pages/Home/Home';
import About from '../pages/About/About';
import Courses from '../pages/Courses/Courses';
import Contact from '../pages/Contact/Contact';
import PressReleases from '../pages/PressReleases/PressReleases';
import ScrollToTop from '../components/ScrollToTop';
// Import admin components
import AdminLogin from '../pages/Admin/Login';
import Dashboard from '../pages/Admin/Dashboard';
import '../styles/Pages.css';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* Admin routes don't have Navbar/Footer */}
        <Routes>
          {/* Admin routes - no layout */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<Dashboard />} />
          
          {/* Public routes with layout */}
          <Route path="/" element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Navbar />
              <About />
              <Footer />
            </>
          } />
          <Route path="/courses" element={
            <>
              <Navbar />
              <Courses />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Navbar />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/press-releases" element={
            <>
              <Navbar />
              <PressReleases />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;